import { Injectable } from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {BehaviorSubject} from "rxjs";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {User} from "../../../../Models/User";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    baseUrl: string = environment.apiUrl;
    private CurrentUserSource = new BehaviorSubject<User | null>(null);
    currentUser = this.CurrentUserSource.asObservable();
    baseheader = new HttpHeaders()
        .set('content-type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');

    constructor(private http: HttpClient, private router: Router, private toatr: ToastrService) {
    }

    getCurrentUserValue() {
        return this.CurrentUserSource.value;
    }

    getuserInfo() {
       this.loadCurrentUser( localStorage.getItem('token'));
        let _user: any = localStorage.getItem('user');
        _user = JSON.parse(_user);
        return _user;
    }

    loadCurrentUser(token: string) {
        let _user: any = localStorage.getItem('user');
        _user = JSON.parse(_user);
        if (_user) {
            this.CurrentUserSource.next(_user);
            return _user.jwToken;
        }
    }

    getTokenAuth(): string {
        return localStorage.getItem("token");
    }

    login(value: any) {
        return this.http
            .post(this.baseUrl + '/Account/login', value, {
                headers: this.baseheader,
            })
            .pipe(
                map((_user: any) => {
                    if (_user) {

                        localStorage.setItem('token', _user.tokenString);
                        localStorage.setItem('user', JSON.stringify(_user.currentUser));
                        this.CurrentUserSource.next(_user.currentUser);
                    }
                })
            );
    }

    Register(value: any) {
      return this.http.post(this.baseUrl + '/Account/Register', value).pipe(
        map((_user: any) => {
          if (_user) {
            this.CurrentUserSource.next(_user);
          }
        })
      );
    }
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.CurrentUserSource.next(null);
    }
}
